import saveQuestionFile from "./saveQuestionFile";
import deleteQuestionFile from "./deleteQuestionFile";

const checkQuestionFiles = async (savedQuestion, updatedQuestion) => {
	if (updatedQuestion?.files) {
		for (const file of updatedQuestion.files) {
			if (file instanceof File) {
				await saveQuestionFile(file, savedQuestion.id);
			}
		}
	}
	if (savedQuestion?.files) {
		for (const savedFile of savedQuestion.files) {
			if (!updatedQuestion.files.find((file) => savedFile.id === file.id)) {
				await deleteQuestionFile(savedFile.id, savedQuestion.id);
			}
		}
	}
};

export default checkQuestionFiles;
